import { MainLayout } from "@/components/layout/main/main";
import { ErrorBoundaryPage } from "@/pages/error-boundary/error-boundary-global";
import { Application } from "@/pages/application";
import { themeControl } from "@/utils";
import { predefineAxiosInterceptors } from "@/guards/auth/predefine-axios-interceptors";

export const App = () => {
  predefineAxiosInterceptors();
  themeControl().setTheme();

  return (
    <ErrorBoundaryPage>
      <MainLayout>
        <Application />
      </MainLayout>
    </ErrorBoundaryPage>
  );
};
